// extracted by mini-css-extract-plugin
export var container = "_gj-0";
export var content = "_gj-3";
export var customerTitle = "_gj-4";
export var empty = "_gj-5";
export var gray = "_gj-6";
export var header = "_gj-7";
export var info = "_gj-8";
export var loading = "_gj-2";
export var loadingCard = "_gj-9";
export var oneLine = "_gj-a";
export var personName = "_gj-e";
export var pillContainer = "_gj-b";
export var selected = "_gj-1";
export var text = "_gj-c";
export var twoLines = "_gj-d";
export var unread = "_gj-f";
export var unreadIndicator = "_gj-g";